import { createContext, useEffect, useState } from "react";
import tokenService from "../services/tokenService";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
 const [isAuthenticated, setIsAuthenticated] = useState(
   () => !!tokenService.getAccessToken(),
 );

  const login = (tokens) => {
    tokenService.setTokens(tokens);
    setIsAuthenticated(true);
  };

  const logout = () => {
    tokenService.clearTokens();
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};